interface FooterProps {
  scrollToSection: (id: string) => void;
}

export default function Footer({ scrollToSection }: FooterProps) {
  return (
    <footer className="bg-[#1A1F2E] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.readdy.ai/image/9041450fc173856249e31fa6f138bbf1/d4dcc7683c3c12c9546c661fe2f1d1c5.png" 
              alt="Logo" 
              className="h-12 w-auto mb-6"
            />
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              IT specialists providing comprehensive SB 2610 compliance solutions for Texas Law Firms.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#e10708] transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#e10708] transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#e10708] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('overview')}
                  className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer"
                >
                  Overview
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('requirements')}
                  className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer"
                >
                  Requirements
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('solutions')}
                  className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer"
                >
                  Our Solutions
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('benefits')}
                  className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer"
                >
                  Benefits
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer">
                  Compliance Assessment
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer">
                  Security Implementation
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer">
                  Staff Training
                </a>
              </li>
              <li>
                <a href="#" className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer">
                  24/7 Monitoring
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-phone-line text-[#e10708] mr-3 mt-1 w-4 h-4 flex items-center justify-center"></i>
                <div>
                  <a href="tel:+18552837848" className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer">
                    (855) 283-7848
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-[#e10708] mr-3 mt-1 w-4 h-4 flex items-center justify-center"></i>
                <div>
                  <a href="mailto:legal@avertnetworkservices.com" className="text-white/70 hover:text-[#e10708] transition-colors text-sm cursor-pointer break-all">
                    legal@avertnetworkservices.com
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-[#e10708] mr-3 mt-1 w-4 h-4 flex items-center justify-center"></i>
                <div className="text-white/70 text-sm">
                  Irving, TX<br />
                  San Antonio, TX
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/50 text-sm mb-4 md:mb-0">
              © 2024 Avert Network Services. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-white/50 hover:text-[#e10708] transition-colors text-sm cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-white/50 hover:text-[#e10708] transition-colors text-sm cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#e10708] transition-colors text-sm cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}